import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyContent"] */ "/app/src/features/pages/components/privacy-policy/PrivacyPolicyContent.component.tsx");
